export enum OrderType {
  NA = 'NA',
  Card = 'Card',
  Invoice = 'Invoice',
}

export enum OrderStatus {
  Created = 'Created',
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  PaymentStarted = 'PaymentStarted',
  Completed = 'Completed',
  Fullfilled = 'Fullfilled',
  Open = 'Open',
  Credited = 'Credited',
  Reserved = 'Reserved',
}

export enum DiscountType {
  Percentage = 'Percentage',
  Fixed = 'Fixed',
}

/** The product a subscription belongs to. Decides the item group, and so the revenue account, of its Maconomy item. */
export enum SubscriptionProduct {
  BFS = 'BFS',
  BVN = 'BVN',
}

export const subscriptionProductNames: Record<SubscriptionProduct, string> = {
  [SubscriptionProduct.BFS]: 'Byggforskserien',
  [SubscriptionProduct.BVN]: 'Våtromsnormen',
};

export enum SubscriptionContentKind {
  Product = 'Product',
  Series = 'Series',
  Guides = 'Guides',
}

export enum SubscriptionSeries {
  Planlegging = 'Planlegging',
  Byggdetaljer = 'Byggdetaljer',
  Byggforvaltning = 'Byggforvaltning',
}

export enum PaymentMode {
  Automatic = 'Automatic',
  Manual = 'Manual',
}
